<template>
  <div
    class="prose w-full max-w-full text-dark prose-headings:text-dark prose-h2:mb-6 prose-h2:text-[28px] prose-h2:font-extrabold prose-h2:uppercase prose-h3:mb-12 prose-h3:mt-4 prose-h3:text-[28px] prose-h3:font-medium prose-h4:mt-12 prose-h4:mb-8 prose-h4:text-[22px] prose-h4:font-extrabold prose-h4:uppercase prose-a:text-dark prose-a:underline prose-strong:text-dark prose-ul:list-square prose-ul:pl-5 prose-li:my-0 prose-li:py-0 prose-hr:my-[70px] prose-hr:border-dark/10"
  ></div>
</template>
